import {Component, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'db-no-websites',
  templateUrl: './no-websites.component.html',
  styleUrls: ['./no-websites.component.scss'],
  standalone: false,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('400ms ease-in', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class NoWebsitesComponent implements OnInit {
  lottieConfig = {
    path: 'assets/images/lotties/10web-loading.json',
    renderer: 'svg',
    autoplay: true,
    loop: true
  };
  loading: boolean = true;

  constructor(
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.loading = false;
    }, 4000);
  }

}
